import { Set }                       from 'immutable';
import _invariant                    from 'invariant';
import {
  compose,
  mapProps,
  setDisplayName,
}                                    from 'recompose';
import _                             from 'underscore';
import autoloader                    from './autoloader';
import mapApiFetch                   from './mapApiFetch';
import mapResourceItemApiUrlFromId   from './mapResourceItemApiUrlFromId';
import mapResourceItemApiUrlFromSlug from './mapResourceItemApiUrlFromSlug';
import mapResourceItemById           from './mapResourceItemById';
import mapResourceItemBySlug         from './mapResourceItemBySlug';
import mapResourceName               from './mapResourceName';
import {
  MAP_RESOURCE_DATA_PROP_RESOURCE_DATA,
  MAP_RESOURCE_DATA_PROP_RESOURCE_ITEM,
  MAP_RESOURCE_PROP_API_FETCH,
  MAP_RESOURCE_PROP_API_FETCH_ERROR,
  MAP_RESOURCE_PROP_API_IS_FETCHING,
  MAP_RESOURCE_PROP_API_URL,
  MAP_RESOURCE_PROP_RESOURCE_ID,
  MAP_RESOURCE_PROP_RESOURCE_NAME,
}                                    from './mapResourceProps.const';
import { ACTIONS }                   from '../../actions/utils/apiResources/apiResourceActions.const';


export const FETCH_BY_ID   = 'FETCH_BY_ID';
export const FETCH_BY_SLUG = 'FETCH_BY_SLUG';


const propsProvided = Set([
  MAP_RESOURCE_PROP_RESOURCE_NAME,
  MAP_RESOURCE_PROP_RESOURCE_ID,
  MAP_RESOURCE_DATA_PROP_RESOURCE_DATA,
  MAP_RESOURCE_DATA_PROP_RESOURCE_ITEM,
  MAP_RESOURCE_PROP_API_URL,
  MAP_RESOURCE_PROP_API_FETCH,
  MAP_RESOURCE_PROP_API_IS_FETCHING,
  MAP_RESOURCE_PROP_API_FETCH_ERROR,
]);


/**
 * Helper to collectively maps all the properties for resource collections, rather than adding them all individually.
 *
 * @param {string}         resourceName
 * @param {string}         fetchBy
 * @param {?Array<string>} propsWhitelist If provided, will remove all mapResourceItem() added props, except this list.
 * @param {?Array<string>} propsBlacklist If provided, will remove these props.
 *
 * @return {function(*=)}
 */
const mapResourceItem = ({resourceName, fetchBy, propsWhitelist = null, propsBlacklist = null}) => {

  const fetchByAllowedValues = Object.keys(mapFunctionsByType);

  _invariant(
    _.contains(fetchByAllowedValues, fetchBy),
    'fetchBy must be one of FETCH_BY_* constant values'
  );

  const propsToRemove = Set([])
    .merge(propsBlacklist || [])
    .merge((propsWhitelist && propsProvided.subtract(propsWhitelist)) || [])
    .toJS();

  return compose(
    mapResourceName(resourceName),
    mapFunctionsByType[fetchBy]({resourceName}),
    autoloader(),
    setDisplayName('RemoveUnwantedProps'),
    mapProps(props => _.omit(props, propsToRemove)),
  );

};


/**
 * Mapping for items by ID.
 *
 * @param {string} resourceName Name of the resource.
 *
 * @return {function}
 */
const mapById = ({resourceName}) => compose(
  mapResourceItemApiUrlFromId(),
  mapResourceItemById({resourceName}),
  mapApiFetch({resourceName, actionGroup: ACTIONS.SHOW}),
);


/**
 * Mapping for items by slug.
 *
 * @param {string} resourceName Name of the resource.
 *
 * @return {function}
 */
const mapBySlug = ({resourceName}) => compose(
  mapResourceItemApiUrlFromSlug(),
  mapResourceItemBySlug({resourceName}),
  mapApiFetch({resourceName, actionGroup: ACTIONS.LIST}),
);


/**
 * Map of mapping functions, by the fetch type.
 *
 * @type {{[p: string]: *}}
 */
const mapFunctionsByType = {
  [FETCH_BY_ID]:   mapById,
  [FETCH_BY_SLUG]: mapBySlug,
};


export default mapResourceItem;


// WEBPACK FOOTER //
// ./src/components/resources/mapResourceItem.js